import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

const isLocalDev = process.env.NODE_ENV === "development";
const rootElementId = isLocalDev ? "root" : "baid-login";
const root = ReactDOM.createRoot(document.getElementById(rootElementId));
const parent = root._internalRoot?.containerInfo?.parentElement;

const personalNumber = parent?.children?.personalNumber?.value;
const sign = root._internalRoot?.containerInfo?.className === "sign"; //returns true if div holding this subrepo has class "sign" and only "sign".

root.render(
  <React.StrictMode>
    <App sign={sign} personalNumber={personalNumber} />
  </React.StrictMode>
);
